// Icon of every AI photo-edit tool (the "extra editing guide" toggles), served from /public/images/photo-tools/.
// One map for each screen that lists the tools — the generate-image editor and Settings → photo edit — so a tool
// wears the same icon everywhere. The art is black/grey line work: invert it on dark surfaces (the editor does it
// with `.toolIcon` in GenerateImage.module.scss, Tailwind screens with `dark:invert`).
const DIR = '/images/photo-tools/';

export const PHOTO_TOOL_ICONS = {
    removeGlasses: `${DIR}new-remove-glases.svg`,
    keepSunGlasses: `${DIR}new-keep-sun-glasses.svg`,
    glowMakeup: `${DIR}new-beutify-face.svg`,
    smoothSkin: `${DIR}new-smooth-skin.svg`,
    fixOilySkin: `${DIR}new-fix-oily-skin.svg`,
    brightenImage: `${DIR}new-brighten-image.svg`,
    studioLighting: `${DIR}new-studio-light.svg`,
    removeStrayHair: `${DIR}new-fix-hair.svg`,
    applyHair: `${DIR}new-apply-hair.svg`,
    removeBeard: `${DIR}new-remove-beard-mustache.svg`,
    addBeard: `${DIR}new-add-beard.svg`,
    keepBeard: `${DIR}new-keep-beard.svg`,
    keepMustache: `${DIR}new-keep-mustache.svg`,
    keepFacialMarks: `${DIR}keep-facial-marks.svg`,
    keepNosePin: `${DIR}new-keep-nose-pin.svg`,
    openEyes: `${DIR}new-open-eye.svg`,
    closeMouth: `${DIR}new-close-mouth.svg`,
    lookAtCamera: `${DIR}new-look-at-camera.svg`,
    straightenHead: `${DIR}new-head-straight..svg`, // (sic) the file name really has two dots
    removeTupi: `${DIR}new-remove-cap.svg`,
    addTupi: `${DIR}new-tupi.svg`,
    showEar: `${DIR}new-show-ear.svg`,
    halfBody: `${DIR}new-half-body.svg`,
    keepSchoolDressDetails: `${DIR}new-school-dress-unchange.svg`,
    keepNamePlate: `${DIR}new-keep-name-plate.svg`,
    lipstick: `${DIR}new-lipstick.svg`,
    showCustomInstruction: `${DIR}new-custom-write.svg`,
};
